import React from 'react';

const OrdifyConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/ordify/dashboard',
			component: React.lazy(() => import('./Dashboard/Dashboard'))
		},
		{
			path: '/apps/ordify/reports/pre-order',
			component: React.lazy(() => import('./Reports/PreOrder'))
		},
		{
			path: '/apps/ordify/reports/post-order',
			component: React.lazy(() => import('./Reports/PostOrder'))
		},
		{
			path: '/apps/ordify/summary/order-summary',
			component: React.lazy(() => import('./Summary/OrderSummary'))
		},
		{
			path: '/apps/ordify/summary/channel-summary',
			component: React.lazy(() => import('./Summary/ChannelSummary'))
		},
		{
			path: '/apps/ordify/summary/template-summary',
			component: React.lazy(() => import('./Summary/TemplateSummary'))
		},
		{
			path: '/apps/ordify/waba-outbox',
			component: React.lazy(() => import('./Waba/WhatsappOutbox'))
		},
		{
			path: '/apps/ordify/users/:userId/details',
			component: React.lazy(() => import('./Users/UserDetails'))
		},
		{
			path: '/apps/ordify/users',
			component: React.lazy(() => import('./Users/Users'))
		},
		{
			path: '/apps/ordify',
			component: React.lazy(() => import('./Ordify'))
		}
	]
};

export default OrdifyConfig;
